/*
    These variables should match ./_variables.scss
*/
export const lxsFormBorderWidth = 1;
export const lxsFormPaddingVertical = 13;
export const lxsFormPaddingHorizontal = 16;
export const lxsFormNotchPadding = 4;
export const lxsFormNotchLeft = lxsFormPaddingHorizontal - lxsFormNotchPadding;
export const lxsFormLabelScale = 0.77;
